<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      dialogCommonIsShow: false
    }
  },
  computed: {
    ...mapGetters({
      dialogIsShowDepository: 'config/getDialogCommonIsShow'
    }),
    dialogIsShow: {
      get() {
        return this.dialogIsShowDepository
      }
    }
  },
  watch: {
    dialogIsShow(newVal, oldVal) {
      if (newVal === false) {
        setTimeout(() => {
          this.dialogCommonIsShow = false
        }, 400)
      } else this.dialogCommonIsShow = true
    }
  },
  methods: {
    handleModalClick() {
      this.$store.commit('config/SET_DIALOG_COMMON', false)
    }
  }
}
</script>

<template>
  <div v-show="dialogCommonIsShow" class="dialog-common" @click.self="handleModalClick">
    <transition name="dialog-fade">
      <div v-if="dialogIsShow" class="dialog-content">
        <div class="dialog-content-main">
          <img
            class="close-btn"
            :src="require('imgs/close-btn.png')"
            alt="close-btn"
            @click="handleModalClick"
          >
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
.dialog-common {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .3);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  .dialog-content {
    width: 1350px;
    height: 755px;
    background: #fff;
    border-radius: 10px;
    margin-top: 126px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .close-btn {
      position: absolute;
      bottom: 0;
      right: -54px;
      width: 44px;
      height: 44px;
      cursor: pointer;
    }
  }
  .dialog-content-main {
    width: 1330px;
    height: 735px;
    background: #fff;
    border: 2px solid #408490;
    border-radius: 8px;
    padding: 25px 30px;
    box-sizing: border-box;
    overflow-y: scroll;
    overflow-x: hidden;
    // &::-webkit-scrollbar { // chrome/safari
    //   display: none;
    // }
    // scrollbar-width: none; // firefox
    // -ms-overflow-style: none; // IE10+
    &::-webkit-scrollbar { // chrome/safari
      width: 5px;
    }
    // scrollbar-width: none; // firefox
    // -ms-overflow-style: none; // IE10+
    &::-webkit-scrollbar-track {
      // background:#e4e4e4;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: #cdcdcd;
      border-radius: 3px;
    }
  }

  .bottom-container {
    width: 1350px;
    height: 100px;
    // border: 1px solid #fff;
    margin-top: 30px;
  }
}

.dialog-fade-modal-enter-active {
  animation: dialog-fade-in 0.4s;
}
.dialog-fade-modal-leave-active {
  animation: dialog-fade-out 0.4s;
}

@keyframes dialog-fade-modal-in {
  0% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes dialog-fade-modal-out {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    transform: translate3d(0, -20px, 0);
    opacity: 0;
  }
}

.dialog-fade-enter-active {
  animation: dialog-fade-in 0.4s;
}
.dialog-fade-leave-active {
  animation: dialog-fade-out 0.4s;
}

@keyframes dialog-fade-in {
  0% {
    transform: translate3d(0, -20px, 0) scale(0);
    opacity: 0;
  }
  100% {
    transform: translate3d(0, 0, 0) scale(1);
    opacity: 1;
  }
}

@keyframes dialog-fade-out {
  0% {
    transform: translate3d(0, 0, 0) scale(1);
    opacity: 1;
  }
  100% {
    transform: translate3d(0, -20px, 0) scale(0);
    opacity: 0;
  }
}
</style>
